import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ProductionProcess, ProductionProcessDetails } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductionProcessService extends TmsWebBaseEditService<ProductionProcess, ProductionProcessDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductionProcess', $localize`Production Process`);
  }
}
